import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Flag, Trophy } from "@phosphor-icons/react";

export default function Landing() {
  return (
    <div className="app-shell">
      <div className="relative min-h-screen overflow-hidden">
        {/* Hero image */}
        <div className="absolute inset-0">
          <img
            src="https://static.prod-images.emergentagent.com/jobs/31ab4da2-b0a1-4d6f-8de3-a1045304dbde/images/a1ab1e6cd8ede713d2e69bf89fd5371c18ce6983827355602ba3c0d03a128798.png"
            alt="UK golf course at golden hour"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-[var(--bg-app)]" />
        </div>

        <div className="relative z-10 flex flex-col min-h-screen p-6">
          <div className="flex items-center" data-testid="landing-logo">
            <img
              src="/fairway-logo-transparent.png"
              alt="Fairway"
              className="h-20 w-auto -ml-2 drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]"
            />
          </div>

          <div className="flex-1 flex flex-col justify-end pb-8 animate-fade-up">
            <p className="label-uppercase text-white/80 mb-3">UK GOLF · FIELD COMPANION</p>
            <h1 className="font-heading font-black tracking-tighter-2 text-white text-5xl sm:text-6xl leading-[0.95] mb-5">
              Every yard.<br/>Every hole.<br/>Every round.
            </h1>
            <p className="text-white/90 text-base mb-8 max-w-xs">
              GPS distance to every pin on the UK's best courses. Track rounds. Crush mates in private leagues.
            </p>

            <div className="grid grid-cols-3 gap-3 mb-8">
              <FeatureBadge icon={MapPin} label="GPS Distances" />
              <FeatureBadge icon={Flag} label="UK · Spain · Portugal" />
              <FeatureBadge icon={Trophy} label="Leagues" />
            </div>

            <Link to="/register" data-testid="cta-get-started" className="btn-primary text-lg w-full justify-center">
              Get started <ArrowRight size={20} weight="bold" />
            </Link>
            <Link to="/login" data-testid="cta-sign-in" className="text-center text-white/90 mt-4 text-sm font-medium hover:text-white">
              Already have an account? <span className="underline">Sign in</span>
            </Link>

            <div className="mt-10 pt-5 border-t border-white/15 flex items-center justify-center gap-4 text-[11px] uppercase tracking-wider text-white/55">
              <Link to="/terms" data-testid="landing-terms-link" className="hover:text-white transition-colors">
                Terms
              </Link>
              <span>·</span>
              <Link to="/privacy" data-testid="landing-privacy-link" className="hover:text-white transition-colors">
                Privacy
              </Link>
              <span>·</span>
              <span>© {new Date().getFullYear()} Fairway Golf</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FeatureBadge({ icon: Icon, label }) {
  return (
    <div className="rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 px-3 py-3 flex flex-col items-center text-white text-center">
      <Icon size={22} weight="duotone" />
      <span className="text-[10px] mt-1 font-semibold uppercase tracking-wider">{label}</span>
    </div>
  );
}
